import ParentSize, {
  ParentSizeProps,
} from '@visx/responsive/lib/components/ParentSize';

import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const ChartContainerStyles = xcss({
  width: '100%',
  height: token('space.800'), // Use 'space.800' without fallback causes ParentSize broken.
});

export const ChartContainer = ({ children, ...props }: ParentSizeProps) => {
  return (
    <Box xcss={ChartContainerStyles}>
      <ParentSize {...props}>
        {provideSize =>
          provideSize.width && provideSize.height && children(provideSize)
        }
      </ParentSize>
    </Box>
  );
};
